export const translations = {
  en: {
    "LeaseRadar.pdf.totalGLA": "Total GLA",
    "LeaseRadar.pdf.footer":
      "Plans produced by: ID Plans, t: 866-857-2545 - Page {pageNumber} / {totalPages}",
    "LeaseRadar.pdf.squareFoot": "Square Foot",
    "LeaseRadar.pdf.available": "AVAILABLE",
    "LeaseRadar.pdf.anchor": "Anchor",
    "LeaseRadar.pdf.tenantRoster": "Tenant Roster",
    "LeaseRadar.pdf.tenant": "Tenant",
    "LeaseRadar.pdf.spaceNumber": "Space #",
    "LeaseRadar.pdf.leaseStart": "Lease Start",
    "LeaseRadar.pdf.leaseExpiring": "Lease Expiring",
    "LeaseRadar.pdf.vacateDate": "Vacate Date",
    "LeaseRadar.pdf.category": "Category",
    "LeaseRadar.pdf.status": "Status"
  },
  es: {
    "LeaseRadar.pdf.totalGLA": "GLA total",
    "LeaseRadar.pdf.footer":
      "Planos producidos por: ID Plans, t: 866-857-2545 - Página {pageNumber} de {totalPages}",
    "LeaseRadar.pdf.squareFoot": "Pie cuadrado",
    "LeaseRadar.pdf.available": "DISPONIBLE",
    "LeaseRadar.pdf.anchor": "Ancla",
    "LeaseRadar.pdf.tenantRoster": "Lista de inquilinos",
    "LeaseRadar.pdf.tenant": "Inquilino",
    "LeaseRadar.pdf.spaceNumber": "Espacio #",
    "LeaseRadar.pdf.leaseStart": "Inicio del contrato de arrendamiento",
    "LeaseRadar.pdf.leaseExpiring": "Vencimiento del contrato de arrendamiento",
    "LeaseRadar.pdf.vacateDate": "Fecha de desocupación",
    "LeaseRadar.pdf.category": "Categoría",
    "LeaseRadar.pdf.status": "Estado"
  }
};

export const translate =
  (language) => (key, params) => {
    let translated = translations[language][key];
    if (!params) return translated;

    for (const [param, value] of Object.entries(params)) {
      translated = translated.replace(`{${param}}`, value);
    }
    return translated;
  };
